export default class ParameterNames {
    public static readonly REQUEST_SOURCE_AUTHENTICATION_CONTROLLER = 'ac';
}